import axios from 'axios'

import i18n from '../i18n'
import { ErrorTypes } from '../types/errors'

const { GenericError, PartnerError, ValidationError } = ErrorTypes

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const errorData = error.response?.data?.error
    if (
      errorData?.type &&
      ![GenericError, PartnerError, ValidationError].includes(errorData.type)
    ) {
      const { params, message, type } = errorData
      const translatedMessage = i18n.t(`errors:${type}`, params || {})
      errorData.originalMessage = message
      errorData.message = translatedMessage
    }

    return Promise.reject(error)
  },
)

api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.common.Accept = 'application/json'

const setAuthHeader = (token: string) => {
  api.defaults.headers.Authorization = `Bearer ${token}`
}

const removeAuthHeader = () => {
  delete api.defaults.headers.Authorization
}

export { api, setAuthHeader, removeAuthHeader }
